var _pattern, _symbol, _symbol2, _pattern2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlanc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    viewBox: "0 0 744.09448819 1052.3622047",
    height: "297mm",
    width: "210mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("marker", {
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "DistanceX",
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      strokeWidth: 0.5
    },
    d: "M 3,-3 L -3,3 M 0,-5 L  0,5",
    id: "path4277"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    height: 8,
    width: 8,
    patternUnits: "userSpaceOnUse",
    y: 0,
    x: 0,
    id: "Hatch"
  }, /*#__PURE__*/React.createElement("path", {
    linecap: "square",
    stroke: "#000000",
    strokeWidth: 0.25,
    d: "M8 4 l-4,4",
    id: "path4280"
  }), /*#__PURE__*/React.createElement("path", {
    linecap: "square",
    stroke: "#000000",
    strokeWidth: 0.25,
    d: "M6 2 l-4,4",
    id: "path4282"
  }), /*#__PURE__*/React.createElement("path", {
    linecap: "square",
    stroke: "#000000",
    strokeWidth: 0.25,
    d: "M4 0 l-4,4",
    id: "path4284"
  }))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "$MODEL_SPACE"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "$PAPER_SPACE"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "*U0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.975635,1034.843105 733.989295,1035.829520",
    id: "path4289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1035.829520 734.975635,1034.843105",
    id: "path4291"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.989295,1035.829520 733.988918,1035.829897",
    id: "path4293"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1035.829520 735.962351,1035.829897",
    id: "path4295"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1037.802351 737.935784,1037.803482",
    id: "path4297"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.936915,1037.803482 737.935784,1037.802351",
    id: "path4299"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1037.803482 730.043938,1039.775182",
    id: "path4301"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1039.775182 732.015485,1037.803482",
    id: "path4303"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1037.803482 737.935784,1039.775182",
    id: "path4305"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.936915,1037.803482 739.909217,1039.775182",
    id: "path4307"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.043938,1039.775182 730.042053,1039.777067",
    id: "path4309"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1039.775182 732.015485,1039.777067",
    id: "path4311"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.882649,1041.748013 741.882649,1041.750652",
    id: "path4313"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.885290,1041.750652 741.882649,1041.748013",
    id: "path4315"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1041.750652 726.869351,1042.950014",
    id: "path4317"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1042.950014 728.068620,1041.750652",
    id: "path4319"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 743.085017,1042.950014 741.882649,1042.950016",
    id: "path4321"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.882649,1042.950016 741.882649,1042.950014",
    id: "path4323"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.882649,1041.750652 741.882649,1042.950014",
    id: "path4325"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.885290,1041.750652 743.085017,1042.950014",
    id: "path4327"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1042.950020 737.935784,1042.950023",
    id: "path4329"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1042.950023 737.935784,1042.950020",
    id: "path4331"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1039.775182 737.935784,1042.950020",
    id: "path4333"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1039.775182 739.909217,1042.950020",
    id: "path4335"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1042.950027 733.988918,1042.950031",
    id: "path4337"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1042.950031 733.988918,1042.950027",
    id: "path4339"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1035.829897 733.988918,1042.950027",
    id: "path4341"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1035.829897 735.962351,1042.950027",
    id: "path4343"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1042.950034 730.042053,1042.950038",
    id: "path4345"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1042.950038 730.042053,1042.950034",
    id: "path4347"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1039.777067 730.042053,1042.950034",
    id: "path4349"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1039.777067 732.015485,1042.950034",
    id: "path4351"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1042.950042 726.869321,1042.950044",
    id: "path4353"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 726.869321,1042.950044 726.869323,1042.950042",
    id: "path4355"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 726.869351,1042.950014 726.869323,1042.950042",
    id: "path4357"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FFFF00",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1042.950014 728.068620,1042.950042",
    id: "path4359"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "*U1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.975654,1028.544066 734.670742,1028.592359",
    id: "path4362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.280566,1028.592359 734.975654,1028.544066",
    id: "path4364"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.670742,1028.592359 734.395677,1028.732512",
    id: "path4366"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.280566,1028.592359 735.555631,1028.732512",
    id: "path4368"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.395677,1028.732512 734.177384,1028.950805",
    id: "path4370"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.555631,1028.732512 735.773924,1028.950805",
    id: "path4372"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.245951,1029.034731 731.962751,1029.091063",
    id: "path4374"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.529151,1029.091063 732.245951,1029.034731",
    id: "path4376"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.705358,1029.034731 737.422158,1029.091063",
    id: "path4378"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.988558,1029.091063 737.705358,1029.034731",
    id: "path4380"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.177384,1028.950805 734.037231,1029.225870",
    id: "path4382"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.773924,1028.950805 735.914077,1029.225870",
    id: "path4384"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.422158,1029.091063 737.182073,1029.251483",
    id: "path4386"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.988558,1029.091063 738.228644,1029.251483",
    id: "path4388"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.962751,1029.091063 731.722666,1029.251483",
    id: "path4390"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.529151,1029.091063 732.769237,1029.251483",
    id: "path4392"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.182073,1029.251483 737.021653,1029.491568",
    id: "path4394"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 738.228644,1029.251483 738.389064,1029.491568",
    id: "path4396"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.722666,1029.251483 731.562246,1029.491568",
    id: "path4398"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.769237,1029.251483 732.929657,1029.491568",
    id: "path4400"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.037231,1029.225870 733.988938,1029.530782",
    id: "path4402"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.914077,1029.225870 735.962370,1029.530782",
    id: "path4404"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.035109,1029.531498 729.788608,1029.597548",
    id: "path4406"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.281610,1029.597548 730.035109,1029.531498",
    id: "path4408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.916201,1029.531498 739.669700,1029.597548",
    id: "path4410"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.162701,1029.597548 739.916201,1029.531498",
    id: "path4412"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.021653,1029.491568 736.965321,1029.774768",
    id: "path4414"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 738.389064,1029.491568 738.445396,1029.774768",
    id: "path4416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.562246,1029.491568 731.505914,1029.774768",
    id: "path4418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.929657,1029.491568 732.985989,1029.774768",
    id: "path4420"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.669700,1029.597548 739.489249,1029.777999",
    id: "path4422"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.162701,1029.597548 740.343152,1029.777999",
    id: "path4424"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 729.788608,1029.597548 729.608157,1029.777999",
    id: "path4426"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.281610,1029.597548 730.462061,1029.777999",
    id: "path4428"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988938,1029.530782 734.037231,1029.835695",
    id: "path4430"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962370,1029.530782 735.914077,1029.835695",
    id: "path4432"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.489249,1029.777999 739.423199,1030.024499",
    id: "path4434"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.343152,1029.777999 740.409202,1030.024499",
    id: "path4436"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 729.608157,1029.777999 729.542107,1030.024499",
    id: "path4438"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.462061,1029.777999 730.528110,1030.024499",
    id: "path4440"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 736.965321,1029.774768 737.021653,1030.057968",
    id: "path4442"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 738.445396,1029.774768 738.389064,1030.057968",
    id: "path4444"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.505914,1029.774768 731.562246,1030.057968",
    id: "path4446"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.985989,1029.774768 732.929657,1030.057968",
    id: "path4448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.037231,1029.835695 734.177384,1030.110760",
    id: "path4450"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.914077,1029.835695 735.773924,1030.110760",
    id: "path4452"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.423199,1030.024499 739.489249,1030.271000",
    id: "path4454"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.409202,1030.024499 740.343152,1030.271000",
    id: "path4456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 729.542107,1030.024499 729.608157,1030.271000",
    id: "path4458"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.528110,1030.024499 730.462061,1030.271000",
    id: "path4460"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.021653,1030.057968 737.182073,1030.298054",
    id: "path4462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 738.389064,1030.057968 738.228644,1030.298054",
    id: "path4464"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.562246,1030.057968 731.722666,1030.298054",
    id: "path4466"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.929657,1030.057968 732.769237,1030.298054",
    id: "path4468"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.177384,1030.110760 734.395677,1030.329053",
    id: "path4470"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.773924,1030.110760 735.555631,1030.329053",
    id: "path4472"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.489249,1030.271000 739.669700,1030.451451",
    id: "path4474"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.343152,1030.271000 740.162701,1030.451451",
    id: "path4476"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 729.608157,1030.271000 729.788608,1030.451451",
    id: "path4478"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.462061,1030.271000 730.281610,1030.451451",
    id: "path4480"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.182073,1030.298054 737.422158,1030.458474",
    id: "path4482"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 738.228644,1030.298054 737.988558,1030.458474",
    id: "path4484"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.722666,1030.298054 731.962751,1030.458474",
    id: "path4486"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.769237,1030.298054 732.529151,1030.458474",
    id: "path4488"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.475199,1030.469205 732.245951,1030.514806",
    id: "path4490"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.245951,1030.514806 732.016704,1030.469205",
    id: "path4492"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.934606,1030.469205 737.705358,1030.514806",
    id: "path4494"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.705358,1030.514806 737.476111,1030.469205",
    id: "path4496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.422158,1030.458474 737.476111,1030.469205",
    id: "path4498"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.988558,1030.458474 737.934606,1030.469205",
    id: "path4500"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.395677,1030.329053 734.670742,1030.469205",
    id: "path4502"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.555631,1030.329053 735.280566,1030.469205",
    id: "path4504"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 731.962751,1030.458474 732.016704,1030.469205",
    id: "path4506"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.529151,1030.458474 732.475199,1030.469205",
    id: "path4508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.992658,1030.514806 734.975654,1030.517499",
    id: "path4510"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.975654,1030.517499 734.958650,1030.514806",
    id: "path4512"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.670742,1030.469205 734.958650,1030.514806",
    id: "path4514"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.280566,1030.469205 734.992658,1030.514806",
    id: "path4516"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.035117,1030.517499 730.035109,1030.517501",
    id: "path4518"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.035109,1030.517501 730.035101,1030.517499",
    id: "path4520"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.916208,1030.517499 739.916201,1030.517501",
    id: "path4522"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.916201,1030.517501 739.916193,1030.517499",
    id: "path4524"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.669700,1030.451451 739.916193,1030.517499",
    id: "path4526"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 740.162701,1030.451451 739.916208,1030.517499",
    id: "path4528"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 729.788608,1030.451451 730.035101,1030.517499",
    id: "path4530"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.281610,1030.451451 730.035117,1030.517499",
    id: "path4532"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.619839,1032.386680 730.350271,1032.386988",
    id: "path4534"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.350271,1032.386988 730.350204,1032.386680",
    id: "path4536"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.049705,1031.005052 730.350204,1032.386680",
    id: "path4538"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.937966,1031.005052 739.619839,1032.386680",
    id: "path4540"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 727.770627,1041.064520 725.856810,1042.978347",
    id: "path4542"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 725.856810,1042.978347 725.856810,1041.064520",
    id: "path4544"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 744.094488,1041.064520 744.094488,1042.978347",
    id: "path4546"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 744.094488,1042.978347 742.180671,1041.064520",
    id: "path4548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.240654,1034.124471 742.180671,1041.064520",
    id: "path4550"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.166364,1034.124471 744.094488,1041.064520",
    id: "path4552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.784934,1034.124471 725.856810,1041.064520",
    id: "path4554"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.710644,1034.124471 727.770627,1041.064520",
    id: "path4556"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 725.856809,1043.508329 725.856809,1045.422155",
    id: "path4558"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 727.770627,1045.422155 725.856809,1043.508329",
    id: "path4560"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 744.094487,1043.508329 742.180670,1045.422155",
    id: "path4562"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 744.094487,1045.422155 744.094487,1043.508329",
    id: "path4564"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 742.180670,1045.422155 735.240654,1052.362205",
    id: "path4566"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 744.094487,1045.422155 737.166363,1052.362205",
    id: "path4568"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 725.856809,1045.422155 732.784933,1052.362205",
    id: "path4570"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 727.770627,1045.422155 734.710643,1052.362205",
    id: "path4572"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "*U2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1035.829520 735.962351,1035.829897",
    id: "path4575"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962728,1035.829897 735.962351,1035.829520",
    id: "path4577"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1035.829897 732.016617,1037.802351",
    id: "path4579"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1037.802351 733.988918,1035.829897",
    id: "path4581"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1035.829897 735.962351,1037.802351",
    id: "path4583"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962728,1035.829897 737.935784,1037.802351",
    id: "path4585"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.016617,1037.802351 732.015485,1037.803482",
    id: "path4587"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1037.802351 733.988918,1037.803482",
    id: "path4589"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1039.775182 739.909217,1039.777067",
    id: "path4591"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.911103,1039.777067 739.909217,1039.775182",
    id: "path4593"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1039.777067 728.071259,1041.748013",
    id: "path4595"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1041.748013 730.042053,1039.777067",
    id: "path4597"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1039.777067 739.909217,1041.748013",
    id: "path4599"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.911103,1039.777067 741.882649,1041.748013",
    id: "path4601"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.071259,1041.748013 728.068620,1041.750652",
    id: "path4603"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1041.748013 730.042053,1041.750652",
    id: "path4605"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.882649,1042.950016 739.909217,1042.950020",
    id: "path4607"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1042.950020 739.909217,1042.950016",
    id: "path4609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.909217,1041.748013 739.909217,1042.950016",
    id: "path4611"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.882649,1041.748013 741.882649,1042.950016",
    id: "path4613"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1042.950023 735.962351,1042.950027",
    id: "path4615"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1042.950027 735.962351,1042.950023",
    id: "path4617"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1037.802351 735.962351,1042.950023",
    id: "path4619"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 737.935784,1037.802351 737.935784,1042.950023",
    id: "path4621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1042.950031 732.015485,1042.950034",
    id: "path4623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1042.950034 732.015485,1042.950031",
    id: "path4625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 732.015485,1037.803482 732.015485,1042.950031",
    id: "path4627"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1037.803482 733.988918,1042.950031",
    id: "path4629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1042.950038 728.068620,1042.950042",
    id: "path4631"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1042.950042 728.068620,1042.950038",
    id: "path4633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.068620,1041.750652 728.068620,1042.950038",
    id: "path4635"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.042053,1041.750652 730.042053,1042.950038",
    id: "path4637"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1043.536561 733.988918,1043.536565",
    id: "path4639"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1043.536565 733.988918,1043.536561",
    id: "path4641"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.842605,1045.509985 728.842615,1045.509994",
    id: "path4643"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1043.536565 733.988918,1045.509985",
    id: "path4645"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1043.536565 735.962351,1045.509985",
    id: "path4647"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1045.509985 735.962351,1045.509994",
    id: "path4649"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.842615,1045.509994 728.842618,1045.509998",
    id: "path4651"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1045.509994 735.962351,1045.509998",
    id: "path4653"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.842618,1045.509998 728.842628,1045.510007",
    id: "path4655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1045.509998 741.110986,1045.510007",
    id: "path4657"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 728.842628,1045.510007 730.815889,1047.483421",
    id: "path4659"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 741.110986,1045.510007 739.136970,1047.483421",
    id: "path4661"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 730.815889,1047.483421 733.988918,1047.483427",
    id: "path4663"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.136970,1047.483421 739.136964,1047.483427",
    id: "path4665"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.136960,1047.483430 739.136955,1047.483436",
    id: "path4667"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1047.483427 733.988918,1047.483430",
    id: "path4669"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 739.136964,1047.483427 739.136960,1047.483430",
    id: "path4671"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1047.483430 733.988918,1047.483436",
    id: "path4673"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1047.483436 733.988918,1050.656694",
    id: "path4675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1047.483436 735.962351,1050.656694",
    id: "path4677"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1050.657072 734.975635,1051.643487",
    id: "path4679"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 734.975635,1051.643487 733.989295,1050.657072",
    id: "path4681"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 733.988918,1050.656694 733.989295,1050.657072",
    id: "path4683"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#FF0000",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M 735.962351,1050.656694 735.962351,1050.657072",
    id: "path4685"
  })), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern",
    patternUnits: "userSpaceOnUse",
    width: 6,
    height: 6,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 744.1307,588.91651 -361.26842,-361.20298 78.6092,0 282.65922,283.0895 0,78.11348 z",
    id: "path4960"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 121.82436,692.24027 209.99468,0 0,-80.52859 80.5326,0 0,80.52859 210.05416,0 -80.52863,80.46918 -129.52553,0 0,129.5295 -40.26828,40.20082 -40.26432,-40.20082 0,-129.5295 -129.46605,0 -80.52863,-80.46918 z",
    id: "path4962"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 171.13456,100.41556 403.4482,0 -13.06717,56.37043 -378.1784,0 -12.20263,-56.37043 z",
    id: "path4964"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 372.08336,0.00211503 4.39802,0.2477804 3.59297,0.55750589 3.84282,0.99112158 3.52952,1.238902 3.59298,1.7345024 3.40658,1.9822432 3.09726,2.3539138 2.97431,2.6636787 2.66499,2.91142 2.35169,3.221264 2.04633,3.345115 1.67355,3.530712 1.36026,3.716706 0.92798,3.9027 0.62263,3.902303 0.18639,3.964566 -0.18639,3.964565 -0.62263,3.9027 -0.92798,3.902303 -1.36026,3.716706 -1.67355,3.531109 -2.04633,3.345115 -2.35169,3.220986 -2.66499,2.911658 -2.97431,2.663401 -3.09726,2.354073 -3.40658,1.982084 -3.59298,1.672756 -3.52952,1.300768 -3.84282,0.991042 -3.59297,0.557585 -4.39802,0.24786 -4.39803,-0.24786 -3.59297,-0.557585 -3.83885,-0.991042 -3.59298,-1.300768 -3.52952,-1.672756 -3.40658,-1.982084 -3.16071,-2.354073 -2.91086,-2.663401 -2.66499,-2.911658 -2.35169,-3.220986 -2.04633,-3.345115 -1.67355,-3.531109 -1.36026,-3.716706 -0.93195,-3.902303 -0.61866,-3.9027 -0.18639,-3.964565 0.18639,-3.964566 0.61866,-3.902303 0.93195,-3.9027 1.36026,-3.716706 1.67355,-3.530712 2.04633,-3.345115 2.35169,-3.221264 2.66499,-2.91142 2.91086,-2.6636787 3.16071,-2.3539138 3.40658,-1.9822432 3.52952,-1.7345024 3.59298,-1.238902 3.83885,-0.99112158 3.59297,-0.55750589 4.39803,-0.2477804 z",
    id: "path4966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 412.35164,297.27803 80.52863,80.46598 0,210.05813 -80.52863,0 0,-290.52411 z",
    id: "path4970"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 573.34544,458.21315 80.52859,80.52863 0,49.06036 -80.52859,0 0,-129.58899 z",
    id: "path4974"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0.03997924,588.91651 0,-78.11348 282.65922076,-283.0895 78.6092,0 L 0.03997924,588.91651 Z",
    id: "path4976"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 90.26488,538.83299 80.4969,-80.52863 0,129.46605 -80.4969,0 0,-48.93742 z",
    id: "path4980"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 251.29041,377.80746 80.52863,-80.52943 0,290.52411 -80.52863,0 0,-209.99468 z",
    id: "path4982"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 260.70908,20.01066 3.09726,0.185597 2.72447,0.371591 2.91087,0.743579 2.91086,1.052909 2.72447,1.300767 2.4786,1.486762 2.41515,1.796487 2.10581,1.920219 1.98288,2.168078 1.79649,2.415939 1.48715,2.601932 1.30077,2.663401 0.93196,2.725664 0.74159,2.911261 0.43227,2.911657 0.1269,2.973524 -0.1269,2.973127 -0.43227,2.911657 -0.74159,2.849396 -0.93196,2.787529 -1.30077,2.601536 -1.48715,2.601932 -1.79649,2.415938 -1.98288,2.168078 -2.10581,1.920219 -2.41515,1.796487 -2.4786,1.548628 -2.72447,1.238902 -2.91086,1.052908 -2.91087,0.743579 -2.72447,0.371591 -3.09726,0.185598 -3.09725,-0.185598 -2.72844,-0.371591 -2.91087,-0.743579 -2.91086,-1.052908 -2.66499,-1.238902 -2.53808,-1.548628 -2.41515,-1.796487 -2.10581,-1.920219 -1.98288,-2.168078 -1.79649,-2.415938 -1.48716,-2.601932 -1.30077,-2.601536 -0.92798,-2.787529 -0.74556,-2.849396 -0.43227,-2.911657 -0.12294,-2.973127 0.12294,-2.973524 0.43227,-2.911657 0.74556,-2.911261 0.92798,-2.725664 1.30077,-2.663401 1.48716,-2.601932 1.79649,-2.415939 1.98288,-2.168078 2.10581,-1.920219 2.41515,-1.796487 2.53808,-1.486762 2.66499,-1.300767 2.91086,-1.052909 2.91087,-0.743579 2.72844,-0.371591 3.09725,-0.185597 z",
    id: "path4984"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 170.48418,40.266549 2.32393,0.155061 1.54665,0.21653 1.95115,0.495719 1.79649,0.650384 1.737,0.805445 1.76476,1.052908 1.64182,1.207969 1.42371,1.269835 1.33249,1.455829 1.20559,1.610493 1.02317,1.703689 0.83677,1.765157 0.65038,1.858353 0.49572,1.920616 0.27761,1.920219 0.12297,2.013017 -0.0912,2.013414 -0.30933,1.951152 -0.46399,1.920218 -0.68211,1.858353 -0.83677,1.765555 -1.02317,1.703688 -1.17386,1.610493 -1.3325,1.424896 -1.42767,1.300768 -1.6101,1.207969 -1.76476,1.052908 -1.70131,0.805445 -1.79648,0.650384 -1.89167,0.46439 -2.22875,0.340658 -1.79649,0.06226 -2.29221,-0.124128 -1.55061,-0.24786 -1.95115,-0.46439 -1.82425,-0.650384 -1.737,-0.805445 -1.76476,-1.052908 -1.61009,-1.207969 -1.42371,-1.300768 -1.33249,-1.424896 -1.20956,-1.610493 -1.0192,-1.703688 -0.83677,-1.765158 -0.68211,-1.858353 -0.464,-1.920615 -0.30933,-1.951152 -0.0951,-2.013414 0.0951,-2.013018 0.27761,-1.920218 0.49572,-1.920219 0.68211,-1.85875 0.83677,-1.765157 0.98747,-1.703689 1.20956,-1.610493 1.33249,-1.455829 1.39198,-1.269835 1.64183,-1.207969 1.76476,-1.052908 1.70527,-0.805445 1.79649,-0.650384 1.8877,-0.495323 2.20099,-0.309725 1.79649,-0.0932 z",
    id: "path4986"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 483.4616,20.01066 3.09725,0.185597 2.72844,0.371591 2.91087,0.743579 2.91086,1.052909 2.66499,1.300767 2.53808,1.486762 2.41515,1.796487 2.10581,1.920219 1.98288,2.168078 1.73304,2.415939 1.55061,2.601932 1.23731,2.663401 0.99144,2.725664 0.74556,2.911261 0.43227,2.911657 0.12298,2.973524 -0.12298,2.973127 -0.43227,2.911657 -0.74556,2.849396 -0.99144,2.787529 -1.23731,2.601536 -1.55061,2.601932 -1.73304,2.415938 -1.98288,2.168078 -2.10581,1.920219 -2.41515,1.796487 -2.53808,1.548628 -2.66499,1.238902 -2.91086,1.052908 -2.91087,0.743579 -2.72844,0.371591 -3.09725,0.185598 -3.09726,-0.185598 -2.72447,-0.371591 -2.91087,-0.743579 -2.91086,-1.052908 -2.72844,-1.238902 -2.47463,-1.548628 -2.41515,-1.796487 -2.10978,-1.920219 -1.97891,-2.168078 -1.79649,-2.415938 -1.55061,-2.601932 -1.23731,-2.601536 -0.93196,-2.787529 -0.74159,-2.849396 -0.43227,-2.911657 -0.18639,-2.973127 0.18639,-2.973524 0.43227,-2.911657 0.74159,-2.911261 0.93196,-2.725664 1.23731,-2.663401 1.55061,-2.601932 1.79649,-2.415939 1.97891,-2.168078 2.10978,-1.920219 2.41515,-1.796487 2.47463,-1.486762 2.72844,-1.300767 2.91086,-1.052909 2.91087,-0.743579 2.72447,-0.371591 3.09726,-0.185597 z",
    id: "path4988"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 573.65477,40.266549 2.29221,0.185994 1.55061,0.185597 1.97891,0.495719 1.79649,0.681317 1.737,0.805445 1.79649,1.052908 1.61009,1.177036 1.42371,1.300768 1.30077,1.424896 1.24128,1.610493 0.99144,1.734622 0.86453,1.734224 0.68211,1.858353 0.43227,1.920616 0.30933,1.920219 0.1269,2.04395 -0.1269,1.982481 -0.24588,1.982085 -0.49572,1.920615 -0.68211,1.858353 -0.86453,1.734225 -0.99144,1.734621 -1.17783,1.610493 -1.36422,1.424896 -1.36026,1.300768 -1.67354,1.177036 -1.737,1.052908 -1.73304,0.805445 -1.79649,0.681317 -1.85994,0.433457 -2.22875,0.371988 -1.79649,0.06187 -2.2922,-0.124128 -1.54665,-0.247464 -1.98288,-0.495719 -1.79648,-0.619451 -1.73304,-0.805445 -1.737,-1.052908 -1.67355,-1.238902 -1.42371,-1.300768 -1.30076,-1.424896 -1.23732,-1.610493 -0.99144,-1.672756 -0.8685,-1.79609 -0.61866,-1.858353 -0.49572,-1.920615 -0.30932,-1.920219 -0.12294,-2.044347 0.12294,-1.982085 0.30932,-1.920218 0.43227,-1.920219 0.68211,-1.858353 0.8685,-1.796487 0.99144,-1.672756 1.17783,-1.610493 1.36025,-1.486762 1.42371,-1.238902 1.61406,-1.238902 1.73304,-1.052908 1.73303,-0.805445 1.79649,-0.619451 1.85994,-0.495323 2.22875,-0.309725 1.79649,-0.124128 z",
    id: "path4990"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0.03997924,610.5973 361.3084,971.80227 l -78.6092,0 -282.65922076,-283.21443 0,-77.99054 z",
    id: "path4992"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 744.1307,610.5973 0,77.99054 -282.65922,283.21443 -78.6092,0 L 744.1307,610.5973 Z",
    id: "path5000"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanc);
export default __webpack_public_path__ + "static/media/logoBlanc.b38dfbc17a8a0d1a51d89b56a2882bf8.svg";
export { ForwardRef as ReactComponent };